export const APP_SET_PARAMS_VALUES = "app/setParamsValues";
export const APP_SET_QUERY_VALUE = "app/setQuery";
export const APP_SET_TABULAR_QUERY_VALUE = "app/setTabularQuery";
export const APP_SET_SHOW_IMMEDIATELY = "app/setShowImmediately";
export const APP_CHANGE_SELECTED_FISCAL_YEAR =  "app/changeSelectedFiscalYear";
export const APP_SET_SEARCH_TERM_VALUE =  "app/setSearchTermValue";
export const APP_SET_HISTORY = "app/setHistory";

export const REQUEST_GET_APIVERSION = "request/getApiVersion";
export const REQUEST_GET_APIVERSION_ERROR = "request/getApiVersionError";
export const REQUEST_GET_METADATA = "request/getMetadata";
export const REQUEST_GET_METADATA_ERROR = "request/getMetadataError";
export const REQUEST_INITIALIZE_GET_TABULAR_DATA = "requests/initializeGetTabularData";
export const REQUEST_GET_TABULAR_DATA = "requests/getTabularData";
export const REQUEST_GET_TABULAR_DATA_ERROR = "requests/getTabularDataError";
export const REQUEST_GET_DISEASES_INJURIES = "request/getDiseasesInjuries";
export const REQUEST_GET_DISEASES_INJURIES_ERROR = "request/getDiseasesInjuriesError";
export const REQUEST_INITIALIZE_GET_DISEASES_INJURIES = "request/iniitalizeGetDiseasesInjuries";
export const REQUEST_GET_EXTERNAL_CAUSES = "request/getExternalCauses";
export const REQUEST_GET_EXTERNAL_CAUSES_ERROR = "request/getExternalCausesError";
export const REQUEST_INITIALIZE_GET_EXTERNAL_CAUSES = "request/initializeGetExternalCauses";
export const REQUEST_GET_DRUGS_TABLE = "request/getDrugsTable";
export const REQUEST_GET_DRUGS_TABLE_ERROR = "request/getDrugsTableError";
export const REQUEST_INITIALIZE_GET_DRUGS_TABLE = "request/initializeGetDrugsTable";
export const REQUEST_GET_NEOPLASMS_TABLE = "request/getNeoplasmsTable";
export const REQUEST_GET_NEOPLASMS_TABLE_ERROR = "request/getNeoplasmsTableError";
export const REQUEST_INITIALIZE_GET_NEOPLASMS_TABLE = "request/initializeGetNeoplasmsTable";
